import { customElement } from 'lit/decorators.js'
import { Scenario } from '@things-factory/integration-ui/dist-client/'

@customElement('scenario-list-page')
export class ScenarioListPage extends Scenario {
  get context() {
    return {
      ...super.context,
      board_topmenu: true
    }
  }
}
